import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import AppUserAdd from './AppUserAdd';
import AppUserUpdate from './AppUserUpdate';
import AppUserChangePassword from './AppUserChangePassword';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, nNU, showConfirm, showToast } from 'util/utils';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_PARENT,
  2: string.ACCOUNT_ROLE_CHILD,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const AppUserList = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [selectedUser, setSelectedUser] = useState(null);
  const [passwordUser, setPasswordUser] = useState(null);
  const [addUser, setAddUser] = useState(null);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [currentUser.accountRole],
  );

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      let data = await sendPost({
        url:
					isAdmin
            ? Urls.appuser.list
            : Urls.appuser.childlist,
        body: {
          id: currentUser.id,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setUsers(result);
        setTotal(total);
      }
      return result;
    },
    [currentUser],
  );
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.id,
        data: isAdmin ? [
          raw.username,
          raw.displayName,
					raw.email,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? string.APP_REGISTRATION_STATUS_CONFIRM
            : raw.registrationStatus === 0
            ? string.APP_REGISTRATION_STATUS_OK
            : string.APP_REGISTRATION_STATUS_NG,
          !nNU(raw.registrationStatus) ||
          raw.registrationStatus === 1 ||
          !nNU(raw.processedAt)
            ? '****/**/**'
            : formatDate(raw.processedAt, 'YYYY/MM/DD'),
          // !nNU(raw.registrationStatus) ||
          // raw.registrationStatus === 1 ||
          // !nNU(raw.expirationDate)
          //   ? '****/**/**'
          //   : formatDate(raw.expirationDate, 'YYYY/MM/DD'),
        ] : [
          raw.username,
          raw.displayName,
					// raw.email,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? string.APP_REGISTRATION_STATUS_CONFIRM
            : raw.registrationStatus === 0
            ? string.APP_REGISTRATION_STATUS_OK
            : string.APP_REGISTRATION_STATUS_NG,
          !nNU(raw.registrationStatus) ||
          raw.registrationStatus === 1 ||
          !nNU(raw.processedAt)
            ? '****/**/**'
            : formatDate(raw.processedAt, 'YYYY/MM/DD'),
          // !nNU(raw.registrationStatus) ||
          // raw.registrationStatus === 1 ||
          // !nNU(raw.expirationDate)
          //   ? '****/**/**'
          //   : formatDate(raw.expirationDate, 'YYYY/MM/DD'),
				],
        raw,
      })),
    [],
  );

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        title={string.APP_USER_MANAGEMENT}
        body={
          <>
            <Table
              className="nowrap"
              mainActions={[
                {
                  icon: 'add',
                  title: string.NEW_ACCOUNT,
                  onClick: () => setAddUser({ valid: true }),
                },
              ]}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={isAdmin ? [
                string.APP_LOGIN_ID,
                string.APP_DISPLAY_NAME,
                string.APP_ID_OWNER,
                string.APP_REGISTRATION_STATUS,
                string.APP_ACTIVATION_DATE,
                // string.APP_EXPIRATION_DATE,
              ] : [
                string.APP_LOGIN_ID,
                string.APP_DISPLAY_NAME,
                string.APP_REGISTRATION_STATUS,
                string.APP_ACTIVATION_DATE,
							]}
              data={dataTable(users)}
              getCSVData={async () => {
                return dataTable(await doSearch(1, total, true));
              }}
              csvFileName="AppUserList"
              isPaging={true}
              actions={[
                { render: 'edit', onClick: ({ raw }) => setSelectedUser(raw) },
								{ render: 'password', onClick: ({ raw }) => setPasswordUser(raw)},
								({raw}) => {
									if (!isAdmin) {
										return null;
									}
									if (raw.registrationStatus === 0) {
										return {
											render: 'ban',
											className: 'color-danger',
											onClick: ({ raw }) => {
												console.log('Ban');
												/* showConfirm({
													body: 'Approve',
													defaultAction: () => {
														sendPost({

														}).then(() => {

														});
													},
												});*/
											},
										};
									} else {
										return {
											render: 'approve',
											onClick: ({ raw }) => {
												// console.log('Approve');
												let user = {
													portalPocId: raw.id,
													processedMessage: currentUser.email,
													username: raw.username,
													displayName: raw.displayName,
													role: raw.role,
													expirationDate: raw.expirationDate,
												};
												showConfirm({
													body: string.APP_ACCOUNT_APPROVE_CONFIRM,
													defaultAction: () => {
														sendPost({
															url: Urls.pocmap.user,
															body: {
																...user,
															},
														}).then((res) => {
															showToast(string.APP_ACCOUNT_APPROVE_SUCCESS, 'success');
															doSearch(page, pageSize);
														}).catch((e) => {
															console.log('Approve error');
														});
													},
												});
											},
											// onClick: ({ raw }) => {
											// 	showConfirm({
											// 		body: getString(string.ACCOUNT_UNASSIGN_CONTRACT_CONFIRM, [
											// 			raw.accountName,
											// 			raw.contractNumber,
											// 		]),
											// 		defaultAction: () => {
											// 			sendPost({
											// 				url: `${Urls.contract.unlink}/${raw.contractId}`,
											// 			}).then(() => {
											// 				showToast(string.ACCOUNT_UNASSIGN_CONTRACT_SUCCESS, 'success');
											// 				doSearch(page, pageSize);
											// 			});
											// 		},
											// 	});
											// },
										};
									}
								},
              ]}
            />
          </>
        }
      />
      <Modal
        show={!!selectedUser}
        onHide={() => setSelectedUser(null)}
        body={
          <>
            {!!selectedUser && (
              <AppUserUpdate
                onUpdated={() => {
                  setSelectedUser(null);
                  doSearch(page, pageSize);
                }}
                data={selectedUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!passwordUser}
        onHide={() => setPasswordUser(null)}
        body={
          <>
            {!!passwordUser && (
              <AppUserChangePassword
                onUpdated={() => {
                  setPasswordUser(null);
                  doSearch(page, pageSize);
                }}
                data={passwordUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!addUser}
        onHide={() => setAddUser(null)}
        body={
          <>
            {!!addUser && (
              <AppUserAdd
                onUpdated={() => {
                  setAddUser(null);
                  doSearch(page, pageSize);
                }}
                data={addUser}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default AppUserList;
